import { Bell, Loader } from "lucide-react";
import React, { useState, useEffect } from "react";
import Spacing from "../Spacing";
import { formatTimeToEST, getInitials, getPractice } from "../../helpers";
import { getAllNotifications } from "../../services/notification";

export default function ViewAllNotifications({ selectedPracticeChange, fetchChangePracticeData }) {
    
  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  let user_id = getPractice("user_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }
  
  const [userAllNotifications, setUserAllNotifications] = useState([]);
  const [groupedNotifications, setGroupedNotifications] = useState({});
  const [loadNotification, setLoadNotification] = useState(true);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);

  const defaultFilter = {
    account_id: account_id,
    location_id: location_id,
    user_id: user_id,
    page: 1
  };
  const [filter, setFilter] = useState(defaultFilter);

  // useEffect(() => {
  //   if (notificationBoxRef.current) {
  //     notificationBoxRef.current.scrollTop = notificationBoxRef.current.scrollHeight;
  //   }
  // }, [userAllNotifications]);

  useEffect(() => {
    getNotifications(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const getNotifications = async (filterData) => {
    setFilter(filter);
    try {
      const response = await getAllNotifications(filterData);
      if (response && !response?.detail) {
        const newNotifications = response?.data?.results || [];
        
        const updatedNotifications = [...userAllNotifications, ...newNotifications];
        const uniqueNotifications = Array.from(
          new Map(updatedNotifications.map((item) => [item.id, item])).values()
        );
  
        setUserAllNotifications(uniqueNotifications);
        groupByDate(uniqueNotifications);
        setTotalNotifications(response?.data?.total_pages);
      }
    } catch (error) {} finally{
      setLoadNotification(false);
      setLoadMoreLoader(false);
    }
  }

  const groupByDate = (notifications) => {
    const grouped = notifications.reduce((acc, notification) => {
      const date = new Date(notification?.created_at).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(notification);
      return acc;
    }, {});
    setGroupedNotifications(grouped);
  };

  const handelLoadMore = () => {
    setLoadMoreLoader(true);
    setFilter({
      ...filter,
      page: filter?.page+1,
    });
  }

  useEffect(() => {
    setFilter({
      ...filter,
      location_id: location_id,
      account_id: account_id,
    });
    setUserAllNotifications([]);
    setLoadNotification(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id]);

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
          <i className="docpro_blue_bg docpro_white_color">
            <Bell width={20} height={20} />
          </i>
          Notifications
        </h2>

        <div className="docpro_page_heading_btns"></div>
      </div>
      <Spacing lg="10" sm="10" />

      <div className="docpro_card">
        {!loadNotification ? (
          userAllNotifications.length > 0 ? (
            <div style={{ maxHeight: '73vh', overflow: 'auto' }}>
              {Object.entries(groupedNotifications).map(([date, notifications]) => (
                <div key={date}>
                  <div className="notification_day_header">{date}</div>

                  <ul className="notification_stepper">
                    {notifications.map((notification) => (
                      <li key={notification.id} className="notification_step no_step" style={{ marginBottom: '5px', paddingBottom: 0 }}>
                        <div className="docpro_message_item_avatar step_indicator">
                          {getInitials(`${notification?.created_by_name}`)}{" "}
                        </div>
                        <div className="step_content" style={{ marginLeft: 0 }}>
                          <p>
                            <strong>{notification?.created_by_name}</strong>
                            <span className="notification_time">{formatTimeToEST(notification?.created_at)}</span> <br />
                            <span className="heading_title">{notification?.title}</span>
                          </p>
                          {notification?.message != null && (
                            <p className="notification_comment" dangerouslySetInnerHTML={{ __html: notification?.message}}></p>
                          )}
                        </div>
                        {/* <div className="step_content">
                          <p>
                            <strong>{notification?.created_by_name}</strong>
                            <span className="heading_title">{notification?.title}</span>
                            <span className="notification_time">{formatTimeToEST(notification?.created_at)}</span>
                          </p>
                          {notification?.message != null && (
                            <p className="notification_comment">{notification?.message}</p>
                          )}
                        </div> */}
                      </li>
                    ))}
                  </ul>

                  <Spacing lg="15" sm="15" />
                </div>
              ))}

              {(totalNotifications !== filter?.page && totalNotifications !== 1) && (
                <div className="flex items-center" style={{ justifyContent: 'center' }}>
                  <button
                    className="docpro_bordered_btn docpro_fw_600 size_lg"
                    onClick={handelLoadMore}
                    disabled = {(loadMoreLoader) ? true : false}
                  >
                    <span>Load More</span>
                    {loadMoreLoader && (
                      <span className="docpro_loading">
                        <Loader width={18} height={18} />
                      </span>
                    )}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="notification_no_data text-center">
              No Notifications Found
            </div>
          )
        ) : (
          <div className="flex items-center loading" style={{ width: '100%', height: '290px', justifyContent: 'center' }}>
            <span className="docpro_loading" style={{ position: 'inherit' }}>
              <Loader width={35} height={35} style={{ color: 'var(--accent)' }} />
            </span>
          </div>
        )}
      </div>
    </>
  );
}
